import script from "./CategoriesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesPage.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesPage.vue?vue&type=style&index=0&id=50b42ae3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b42ae3"]])

export default __exports__